// START_MODULE components_molecules_news_styled_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import styled, { css } from 'styled-components';

export const NewsImage = styled.img`
  width: 100%;
  max-height: 400px;
  object-fit: cover;

  margin-bottom: 12px;
`;

export const NewsTitle = styled.h2`
  ${({ theme }) => css`
    font-size: 1.4rem;
    margin-left: 32px;
    margin-bottom: 12px;
    position: relative;
    &::before {
      content: '';
      display: block;
      width: 6px;
      height: 100%;
      background-color: ${theme.accentColor};

      position: absolute;
      top: 0;
      left: -12px;
    }
  `};
`;

export const NewsSubtext = styled.p`
  font-size: 0.9rem;
  color: #a7a7a7;
  margin-bottom: 12px;
`;

export const NewsContent = styled.div`
  p {
    margin-bottom: 8px;
  }
`;

export const NewsContentLimited = styled(NewsContent)`
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const LinkWrapper = styled.div`
  display: flex;
  justify-content: end;

  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);

    display: block;
    width: 70%;
    height: 3px;
    background-color: #dadada;
  }
`;

// END_MODULE components_molecules_news_styled_ts
